<template>
  <div>
    <populate-form
      formTitle="自訂外部預約類型維護"
      fkey="pe01"
      ref="filterForm"
      populateOptionVar="filterOptions"
      formDataObjVar="filterData"
    ></populate-form>
    <b-table
      :items="extTypes"
      :fields="extFields"
    >
      <template slot="actions" slot-scope="row">
        <b-button :class="checkMobile()?'':'mr-3'" @click="showEditType(row.item)">編輯</b-button>
        <b-button @click="removeEditType(row.item.id)">刪除</b-button>
      </template>
    </b-table>
    <b-modal
      v-model="modalShowAdd" 
      centered
      hide-header
      hide-footer
      :static="true"
    >
      <populate-form
        formTitle="新增自訂外部預約類型"
        fkey="ae01"
        ref="addForm"
        :parentVue="this"
        populateOptionVar="addOptions"
        formDataObjVar="addData"
      ></populate-form>
    </b-modal>
    <b-modal
      v-model="modalShowUpd" 
      centered
      hide-header
      hide-footer
      :static="true"
    >
      <populate-form
        formTitle="編輯自訂外部預約類型"
        fkey="ae0ㄉ"
        ref="editForm"
        :parentVue="this"
        populateOptionVar="editOptions"
        formDataObjVar="editData"
      ></populate-form>
    </b-modal>
  </div>
</template>

<script>


export default {
  name: 'StoreExtRvTypeManage',
  components:{
    
  },
  props: {
    
  },
  data: function () {
    return {
      service_minute_unit:60,
      modalShowAdd:false,
      modalShowUpd:false,
      extTypes:[],
      extFields:[
        {
          key:'ext_src_type_name',
          label:'自訂類型名稱'
        },
        {
          key:'default_minutes',
          label:'事件套用預設分鐘數'
        },
        {
          key:'actions',
          label:'操作'
        },
      ],
      filterData:{},
      filterOptions:[
        {
          componentType:'span',
          col:10,
          placeholder:'',
        },
        {
          componentType:'b-button',
          col:2,
          placeholder:"新增",
          execCallback:this.showAddType
        },
        {
          componentType:'b-button',
          col:12,
          placeholder:"跳轉測試",
          execCallback:this.testGo
        }
      ],
      addData:{},
      addOptions:[
        {
          componentType:'text',
          akey:'ext_src_type_name',
          col:12,
          placeholder:"輸入自訂預約類型名稱"
        },
        {
          componentType:'span',
          col:6,
          placeholder:'套用分鐘數(預設值0不套用)'
        },
        {
          componentType:'text',
          akey:'default_minutes',
          col:3,
          placeholder:"分鐘數",
          defaultValue:'0'
        },
        {
          componentType:'b-button',
          col:3,
          placeholder:'確認',
          execCallback:this.confirmAdd
        }
      ],
      editData:{},
      editOptions:[
        {
          componentType:'text',
          akey:'ext_src_type_name',
          col:12,
          placeholder:"輸入自訂預約類型名稱"
        },
        {
          componentType:'span',
          col:6,
          placeholder:'套用分鐘數(預設值0不套用)'
        },
        {
          componentType:'text',
          akey:'default_minutes',
          col:3,
          placeholder:"分鐘數",
          defaultValue:'0'
        },
        {
          componentType:'b-button',
          col:3,
          placeholder:'確認',
          execCallback:this.confirmUpd
        }
      ]
    }
  },
  methods: {
    testGo() {
      this.$bus.linkCallStack = [
        {landingComponent:'StoreExtRvTypeManage',params:{}},
        {landingComponent:'StoreRcManage',params:{open_date:'2019-06-20',highlight_from:'2019-06-20 13:30:00',highlight_to:'2019-06-20 15:30:00'}}
      ]
      this.$bus.landingComponent = "StoreRcManage"
    },
    showAddType() {
      this.addData.ext_src_type_name = ''
      this.addData.default_minutes = 0
      this.$refs.addForm.initDefault()
      this.modalShowAdd = true
    },
    showEditType(item) {
      this.editData.ext_src_type_name = item.ext_src_type_name
      this.editData.default_minutes = item.default_minutes
      this.editData.type_id = item.id
      this.$refs.editForm.refreshModelVar()
      this.modalShowUpd = true
    },
    removeEditType(id, confirm_remove = 0) {
      if (confirm_remove === 0) {
          this.$bus.fnShowConfirm("確認要刪除嗎?", () => {
          let Param = {
            'module':'store',
            'method':'removeExtSrcTypeById',
            'store_id': this.$bus.session.merchant_store_id,
            'type_id':id,
            'confirm_remove':confirm_remove
          }
          this.$bus.apiCall(Param, function (data, vm) {
            if (data.ok === 0) {
                if (!data.data.confirm_remove) {
                  vm.$bus.fnClosePopup()
                  vm.$bus.fnShowInfo(data.msg)
                  return
                }
                else {
                  // 這就很機車了,要再呼叫一次刪除傳強制刪除
                  vm.$bus.fnClosePopup()
                  vm.$bus.fnShowConfirm(data.msg, () => {
                    vm.$bus.fnClosePopup()
                    vm.removeEditType(id, 1)
                  },vm)
                  return
                }
              }
            vm.$bus.fnClosePopup()
            vm.$bus.fnShowInfo("刪除完成")
            vm.get_ext_types()
          }, this)
        })
      }
      else {
        // 機車要複製一次,就是不用再問一次而已
        let Param = {
          'module':'store',
          'method':'removeExtSrcTypeById',
          'store_id': this.$bus.session.merchant_store_id,
          'type_id':id,
          'confirm_remove':confirm_remove
        }
        this.$bus.apiCall(Param, function (data, vm) {
          if (data.ok === 0) {
            vm.$bus.fnClosePopup()
            vm.$bus.fnShowInfo(data.msg)
            return
          }
          vm.$bus.fnClosePopup()
          vm.$bus.fnShowInfo("刪除完成")
          vm.get_ext_types()
        }, this)
      }
    },
    get_ext_types() {
      let Param = {
        'module':'store',
        'method':'getExtSrcTypes',
        'store_id': this.$bus.session.merchant_store_id,
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
            vm.$bus.fnShowInfo(data.msg)
            return
          }
        vm.extTypes =data.data
      }, this)
    },
    confirmAdd() {
      if (this.addData.ext_src_type_name === '') {
        this.$refs.addForm.triggerAlert('類型名稱不能空白')
        return
      }
      const default_minutes = parseInt(this.addData.default_minutes)
      if ( !default_minutes && default_minutes !== 0) {
        this.$refs.addForm.triggerAlert('分鐘數請填寫數字')
        return
      }
      if (default_minutes % this.service_minute_unit !== 0) {
        this.$refs.addForm.triggerAlert('分鐘數不符合設定,需是'+this.service_minute_unit+'的倍數')
        return
      }
      let Param = {
        'module':'store',
        'method':'addExtSrcType',
        'store_id': this.$bus.session.merchant_store_id,
        'type_name':this.addData.ext_src_type_name,
        'default_minutes':this.addData.default_minutes
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
          //vm.$bus.fnClosePopup()
          vm.$refs.addForm.triggerAlert(data.msg)
          return
        }
        setTimeout(() => {
          vm.get_ext_types()
        }, 50);
        vm.$bus.fnClosePopup()
        vm.$bus.fnShowInfo("更新成功")
        vm.modalShowAdd = false
      }, this)

    },
    confirmUpd() {
      if (this.editData.ext_src_type_name === '') {
        this.$refs.editForm.triggerAlert('類型名稱不能空白')
        return
      }
      const default_minutes = parseInt(this.editData.default_minutes)
      if ( !default_minutes && default_minutes !== 0) {
        this.$refs.editForm.triggerAlert('分鐘數請填寫數字')
        return
      }
      if (default_minutes % this.service_minute_unit !== 0) {
        this.$refs.editForm.triggerAlert('分鐘數不符合設定,需是'+this.service_minute_unit+'的倍數')
        return
      }
      let Param = {
        'module':'store',
        'method':'updExtSrcTypeName',
        'type_id':this.editData.type_id,
        'store_id': this.$bus.session.merchant_store_id,
        'type_name':this.editData.ext_src_type_name,
        'default_minutes':this.editData.default_minutes
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
          //vm.$bus.fnClosePopup()
          vm.$refs.editForm.triggerAlert(data.msg)
          return
        }
        setTimeout(() => {
          vm.get_ext_types()
        }, 50);
        vm.$bus.fnClosePopup()
        vm.$bus.fnShowInfo("建立成功")
        vm.modalShowUpd = false
      }, this)

    },
    get_date_data() {
      let Param = {
        'module':'store',
        'method':'getStoreReserveViewOneDay',
        'date': this.filterData.viewDate,
        'store_id': this.$bus.session.merchant_store_id,
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
            vm.$bus.fnShowInfo(data.msg)
            return
          }
        // 成功時無論如何都是已確認(由未設定變已設定 或已設定的更新)
        vm.day_reserves_all = vm.getSimpleReserve(data.data.day_reserves)
        vm.day_reserves = vm.day_reserves_all
        vm.processDateData(data.data.res_map)
      }, this)
    },
  },
  computed: {
    
  },
  created() {
    if (!this.$bus.session.hasOwnProperty('store_service_rule')) {
      // 沒有就抓api寫到session裡,之後讀session
      let Param = {
        'module':'store',
        'method':'getStoreServiceRule',
        'store_id': this.$bus.session.merchant_store_id,
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
            vm.$bus.fnShowInfo(data.msg)
            return
          }
        vm.$bus.session.store_service_rule = data.data
        vm.service_minute_unit = parseInt(data.data.service_minute_unit)
      }, this)
    }
  },
  mounted () {
    this.get_ext_types()
    this.$refs.addForm.initDefault()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
